import React from 'react';

import {message} from 'antd';
import {observable, computed, action} from "mobx";
import { saveAs } from 'file-saver';
import { http, addVisitLog, history } from 'libs';

class Store {
  @observable records = []
  @observable measureCert = []
  @observable recordSerial = '';
  @observable isFetching = false;
  @observable record = {};
  @observable fetching = false;
  @observable detailFetching = false;
  @observable formVisible = false;
  @observable selectDisable = false;
  @observable checkEndNumLoading = false;
  @observable f_type = 'Sale';
  @observable rowId = null;
  @observable certEndNum = 0;
  @observable rentEndNum = 0;
  //搜索条件
  @observable page = 1;
  @observable pageSize = localStorage.getItem('devicePageSize') || 10;
  @observable pageTotal = 0;
  // @observable catalog = null; // 设备类型(销售Sale/租赁Rent/仓储Store) 必填
  // @observable keywords = null; // 关键字搜索(设备名称、货号、PO号)
  @observable orgName = null; // 客户名称
  @observable invoiceTitle = null; // 发票抬头
  @observable projectNo = null; // 项目号
  @observable purchaseNo = null; // PO号
  @observable productName = null; // 设备名称
  @observable factoryCode = null; // 货号
  @observable brandName = null; // 品牌
  @observable materialCode = null; // 物料编码
  @observable deviceSerialNo = null; // 设备序列号
  @observable centerNo = null; // 中心号
  @observable orderCreatedAt = null; // 订单创建开始时间
  @observable name = null; // 联系人
  @observable applyUserId = null; // 申请人ID
  @observable applyUserName = null; // 申请人名称
  @observable storeName = null; // 存放点
  @observable certEndDate = null; // 校准结束日期
  @observable startDate = null; // 租赁起租日期
  @observable endDate = null; // 租赁到期日期
  @observable noticeDate = null; // 租赁到期提醒日期

  @observable spp = {}

  // 过滤
  // @computed get filterRecords() {
  //   return this.records.filter(v => {
  //     let isOK = true
  //     if (isOK && this.spp.brand) { // 品牌
  //       isOK = isOK && (v.brand.indexOf(this.spp.brand) !== -1)
  //     }
  //     if (isOK && this.spp.name) { // 产品名称
  //       isOK = isOK && (v.name.indexOf(this.spp.name) !== -1)
  //     }
  //     if (isOK && this.spp.factory_code) { // 货号
  //       isOK = isOK && (v.factory_code.indexOf(this.spp.factory_code) !== -1)
  //     }
  //     if (isOK && this.spp.serial) { // 序列号
  //       isOK = isOK && (v.serial.indexOf(this.spp.serial) !== -1)
  //     }
  //     if (isOK && this.spp.extra_sn) { // 所属项目
  //       isOK = isOK && (v.extra_sn && (v.extra_sn.indexOf(this.spp.extra_sn) !== -1))
  //     }
  //     if (isOK && this.spp.location) { // 投放地点
  //       isOK = isOK && (v.location.indexOf(this.spp.location) !== -1)
  //     }
  //     if (isOK && typeof this.spp.type !== 'undefined') { // 设备属性
  //       isOK = isOK && (v.type * 1 === this.spp.type * 1)
  //     }

  //     return isOK
  //   })
  // }

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    this.fetchRecords()
}

  //获取
  fetchRecords = () => {
    this.fetching = true;
    let query = {
      catalog :this.f_type,
      orgName : this.orgName,
      invoiceTitle : this.invoiceTitle,
      projectNo :this.projectNo,
      purchaseNo :this.purchaseNo,
      productName :this.productName,
      factoryCode :this.factoryCode,
      brandName :this.brandName,
      materialCode :this.materialCode,
      deviceSerialNo :this.deviceSerialNo,
      centerNo :this.centerNo,
      orderCreatedAt1 :this.orderCreatedAt&&this.orderCreatedAt[0],
      orderCreatedAt2 :this.orderCreatedAt&&this.orderCreatedAt[1],
      name :this.name,
      applyUserId :this.applyUserId,
      applyUserName :this.applyUserName,
      storeName :this.storeName,
      certEndDate1 :this.certEndDate&&this.certEndDate[0],
      certEndDate2 :this.certEndDate&&this.certEndDate[1],
      startDate1 :this.startDate&&this.startDate[0],
      startDate2 :this.startDate&&this.startDate[1],
      endDate1 :this.endDate&&this.endDate[0],
      endDate2 :this.endDate&&this.endDate[1],
      noticeDate1 :this.noticeDate&&this.noticeDate[0],
      noticeDate2 :this.noticeDate&&this.noticeDate[1],
    }
    http.post('/javaApi/front/device/list',{       
      pageNo: this.page,
      pageSize: this.pageSize,
      param: query, 
    })
    .then(action('a', res => {
      this.records = res.data.result.data;
      this.pageTotal = res.data.result.pageInfo.totalRows;
      // this.page_total_price = res.total_price || 0;
      // this.page_total_price_without_tax = res.total_price_without_tax || 0;
      // if (this.f_type === '1') {
      //     this.records = res.sale
      // } else if (this.f_type === '2') {
      //     this.records = res.lease
      // } else if (this.f_type === '3') {
      //     this.records = res.serve
      // } else {
      //     this.records = res.period
      // }
  }))
    .finally(action('b', () => this.fetching = false))
  };

  async exportLog(data) {
    const url = '/javaApi/front/export/deviceExcel';
    const res = await http({
      url: url,
      method: 'get',
      params:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = () => {
    const query = { 
      pageNo: this.page,
      pageSize: this.pageSize,
      catalog :this.f_type,
      orgName : this.orgName,
      invoiceTitle : this.invoiceTitle,
      projectNo :this.projectNo,
      purchaseNo :this.purchaseNo,
      productName :this.productName,
      factoryCode :this.factoryCode,
      brandName :this.brandName,
      materialCode :this.materialCode,
      deviceSerialNo :this.deviceSerialNo,
      centerNo :this.centerNo,
      orderCreatedAt1 :this.orderCreatedAt&&this.orderCreatedAt[0],
      orderCreatedAt2 :this.orderCreatedAt&&this.orderCreatedAt[1],
      name :this.name,
      applyUserId :this.applyUserId,
      applyUserName :this.applyUserName,
      storeName :this.storeName,
      certEndDate1 :this.certEndDate&&this.certEndDate[0],
      certEndDate2 :this.certEndDate&&this.certEndDate[1],
      startDate1 :this.startDate&&this.startDate[0],
      startDate2 :this.startDate&&this.startDate[1],
      endDate1 :this.endDate&&this.endDate[0],
      endDate2 :this.endDate&&this.endDate[1],
      noticeDate1 :this.noticeDate&&this.noticeDate[0],
      noticeDate2 :this.noticeDate&&this.noticeDate[1],
    }
    this.exportLog(query).then(res => {
      if (res) {
        let url = window.URL.createObjectURL(
          new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        saveAs(url,'设备列表.xls');
      } else {
        message.error('导出失败');
      }
    });
    let eventCode = '';
    let eventName = '';
    if (this.f_type==='Sale') {
      eventCode = 'ExportSaleDevice';
      eventName = '导出销售设备';
    }else{
      eventCode = 'ExportRentDevice';
      eventName = '导出租赁设备';
    }
    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    })
  }


  // 添加、更新项目
  updateRecord = (data, index = 0) => {
    const key = 'addProject'
    message.loading({content: 'Loading...', key})

    http.post('/api/front/device/', data)
      .then(res => {
        this.records[index] = data
        this.records[index]['isEdit'] = false
        this.page = 1;
        this.pageTotal = 0;
        this.fetchRecords()
        message.success({content: data['id'] ? '保存成功!' : '修改成功!', key, duration: 1});
      })
  }

  //删除
  delRecord = (id, index = -1) => {
    const key = 'deleteProject'
    message.loading({content: 'Loading...', key})
    http.delete('/api/front/device/?id=' + id)
      .then(res => {
        this.records.splice(index, 1)
        this.page = 1;
        this.pageTotal = 0;
        this.fetchRecords()
        message.success({content: '已删除!', key, duration: 2});
      })
  }

  // 修改关联设备项目编号
  updateProject = (data) => {
    const key = 'updateProject'
    message.loading({content: 'Loading...', key})

    http.patch('/api/front/device/', data)
      .then(res => {
        this.page = 1;
        this.pageTotal = 0;
        this.fetchRecords()
        message.success({content: '修改成功!', key, duration: 1});
      })
  }

  // 计量
  handleMeasureAndRepair = (serial, isRepair = true) => {
    const key = 'handleMeasure'
    const data = {serial: serial, action: isRepair ? 'repair' : 'measure'}
    message.loading({content: 'Loading...', key})

    http.patch('/api/front/device/', data)
      .then(res => {
        this.page = 1;
        this.pageTotal = 0;
        this.fetchRecords()
        message.success({content: isRepair ? '已申请维修!' : '已提交计量!', key, duration: 1});
      })
  }

  // 获取计量证书
  fetchMeasureCert = () => {
    const key = 'fetchMeasureCert'
    message.loading({content: 'Loading...', key})
    return http.get('/api/front/device/measure/?serial=' + this.recordSerial)
      .then(res => {
        message.destroy(key)
        this.measureCert = res
      }).finally(() => {
        message.destroy(key)
      })
  }

  fetchDetail = () => {
    this.detailFetching = true;
    let query = {
      id: this.rowId
    }
    http.get('/javaApi/front/device/getDetail',{ params: query })
      .then(action('a', res => {
        this.detailFetching = false;
        this.record = res.data.result || {};
        addVisitLog({
          pageName: '设备详情页',
          fromPageUrl: window.referrerUrl,
          pageUrl:`${window.location.origin}${history.location.pathname}`,
          eventCode: "DeviceDetail",
          eventName: "查看设备详情",
          content: JSON.stringify(res.data.result),
        })
    }))
      .finally(action('b', () => this.fetching = false))
  };

  //过期证书数量
  fetchCheckEndNum = () => {
    this.checkEndNumLoading = true;
    let query = {
      catalog: this.f_type
    }
    http.get('/javaApi/front/device/checkEndNum/',{ params: query })
      .then(action('a', res => {
        this.certEndNum = res.data.result.certEndNum;
        this.rentEndNum = res.data.result.rentEndNum;
    })).finally(action('b', () => this.checkEndNumLoading = false))
  };

  showForm = (info) => {
    this.rowId = info.id;
    this.formVisible = true;
    this.fetchDetail();
  }

}

export default new Store()
